import React from "react";
import PropTypes from "prop-types";

// import { NotebookExpDesignWeb } from "@learningblocks/simulations/shared-components";
import { Utilities } from "@learningblocks/exp-constants";
const { TOUR_PROPERTIES, VIEW_TYPE } = Utilities;
import {HighlightWrapper} from "@learningblocks/storybook-components";
import {Modal} from "@learningblocks/shared-components";

import { LevelSelector } from "@learningblocks/simulations/shared-components";
import { PageTour } from "./PageTour";

import "./style.scss";

export function Home(props) {

  const renderContent = () => {
    if (props.showLevelSelector) return null;
    else
      return (
        <>
          <NotebookExpDesignWeb />
        </>
      );
  };

  const handleJoyrideCallback = ({ action, index, status, lifecycle }) => {
    if (
      action === TOUR_PROPERTIES.NEXT &&
      index === props.stepIndex &&
      lifecycle === TOUR_PROPERTIES.COMPLETE
    ) {
      props.incrementTour();
    } else if (status === TOUR_PROPERTIES.FINISH) {
      props.endTour();
    } else if (action === TOUR_PROPERTIES.CLOSE) {
      props.endTour();
    }
  };
  return (
    <>
      <Modal className="levelModal" isOpen={props.showLevelSelector}>
        <LevelSelector
          title={props.levelSelectorData.title}
          levels={props.levelSelectorData.levels}
          default={props.levelSelectorData.default}
          onSetLevel={props.onSetLevel}
          buttonText={props.levelSelectorData.buttonText}
        />
      </Modal>
      <PageTour handleJoyrideCallback={handleJoyrideCallback} />
      <HighlightWrapper />
      {renderContent()}
    </>
  );
}

Home.propTypes = {
  /**
   * bool value to show level selector
   */
  showLevelSelector: PropTypes.bool.isRequired,
  /**
   * function to invoke when level is selected
   */
  onSetLevel: PropTypes.func.isRequired,
  /**
   *  function for ending tour
   */
  endTour: PropTypes.func,
  /**
   *  function to  incrementing stepIndex
   */
  incrementTour: PropTypes.func,
  /**
   *  index for Page tour
   */
  stepIndex: PropTypes.number,
};
